document.addEventListener('DOMContentLoaded', function() {
    let tabs = document.querySelectorAll(".product__color-picker-tab"),
        contents = document.querySelectorAll(".product__color-picker__color");

    tabs.forEach(tab => {
        tab.addEventListener("click", function() {
            console.log("Tab clicked:", tab);
            let selectedTitle = tab.dataset.title;
            //alert('ff');

            // Update URL with selected shade
            const url = new URL(window.location.href);
            url.searchParams.set("shade", selectedTitle);
            window.history.pushState({ path: url.href }, "", url.href);

            // Update active tab
            let activeTab = document.querySelector(".product__color-picker-tab.active");
            if (activeTab) {
                activeTab.classList.remove("active");
            }
            tab.classList.add("active");

            // Show/Hide content divs based on selectedTitle
            contents.forEach(content => {
                console.log("Content div:", content);
                if (selectedTitle === 'all' || content.dataset.associatedTab === selectedTitle) {
                    content.classList.remove("hide");
                } else {
                    content.classList.add("hide");
                }
            });
        });
    });
});

 


